var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('VPageCtn',[_c('VSiteLoader'),_c('main',{staticClass:"site-main"},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }